import { AuthZeroProvider } from './providers/AuthZeroProvider';
import { DummyProvider } from './providers/DummyProvider';

export class AuthProviderFactory {
    constructor() { }

    build(authConfig) {
        if(authConfig) {
            return (authConfig.auth ? new AuthZeroProvider(authConfig.auth) : new AuthZeroProvider(authConfig.authConfig));
        }
        else {
            return new DummyProvider();
        }
    }
}

const authFactory = new AuthProviderFactory();
export default authFactory;